import React, { useState } from 'react'
import './App.css';
import Sidebar from './components/Sidebar/Sidebar'
import NFTCard from './components/NFT-card/NFT-card'
import MintButton from './components/MintButton/MintButton'
import Art from './assets/art-icon.png'
import Coffee from './assets/coffee-icon.png'
import Beats from './assets/sudan-beats.png'
import useContract from './hooks/useContract'
import { SpringSpinner } from 'react-epic-spinners'
import { useAppState } from '@laststance/use-app-state'


function App() {
  useContract()

  const [appState, setAppState] = useAppState()
  const [modal, setModal] = useState(false)
  const [newnft, setNewnft] = useState(false)

  const startFlow = async () => {
		if (!appState.user) {
			return
		}

		setAppState({isLoading: true})
		try {
			appState.contract.methods
				.makeAffiliateLink(appState.address, '0xF2d68898557cCb2Cf4C10c3Ef2B034b2a69DAD00', 400000)
				.send({from: appState.address})
				.then((res) => {
					console.log("!!!! then", res)
				}).catch((err) => {
          setNewnft(false);
					console.log("!!!! err", err)
				})
			
			// await appState.user.flow({
			//     // recipient: '0x961288CC232D185daEbbc0C02E162f298f600E4B',
			//     recipient: '0x8010e7cef5ff8ed4df647050c5f6f95ab43a35e6',
			//     flowRate: '38580246913580'
			// });
		} finally {
			setAppState({isLoading: false})
		}

		// const details = await appState.user.details();
		// console.log(details)
	} 


  return (
    <div className="dasboard-ctn">
      <Sidebar />
      <div className="body-ctn" onClick={(e) => {
        if (e.target.className == 'modal') {
          setModal(!modal);
        }
      }}>
        <NFTCard
          title="ArtTools.com"
          image={Art}
          open="4"
          generating="~$30.50/month"
          paid={503.23}
          link=".../0ax23...87ixv/"
        />
        {/* <NFTCard
          title="CryptoCoffee.io"
          image={Coffee}
          open="6"
          generating="~$12.78/month"
          paid={823.14}
          link=".../0z9ca...32mnc/"
        /> */}
        {newnft ? 
          <NFTCard
            title="Sudan Beats"
            image={Beats}
            open="0"
            generating="~$0.00/month"
            paid={0}
            link=".../3fcda...98cna/"
            zero
          /> : null}
        <div onClick={() => setModal(!modal)}>
          <MintButton />
        </div>
        <div className="spinner" style={{ visibility: appState.isLoading ? 'visible' : 'hidden' }}>
          <SpringSpinner color="#175DF1" />
        </div>

        <div className="modal" style={{ visibility: modal ? 'visible' : 'hidden' }}>
          <div className="modal-card">
            <h3>Mint New NFT Affiliate Link</h3>
            <select name="company" id="company">
              <option value="Select Company">Select Company</option>
              <option value="sudan beats">Sudan Beats</option>
            </select>
            <div className="submit-btn"  onClick={() => {
              startFlow();
              setModal(!modal);
              setNewnft(!newnft);
        }}>Mint NFT</div>
           
          </div>
        </div>

      </div>

    </div>
  );
}

export default App;
